import session from "../../api/session";
export const state = {
    totalPeople: 0,
    peopleByRole: new Object(),
    loading: false,
    error: false,
    devices: [],
    departments: [],
    employmentRelationShips: [],
    roles: [],
    standarRoles: [
        { id: 1, name: "EXECUTIVE_MANAGER" },
        { id: 2, name: "MANAGER" },
        { id: 3, name: "CHIEF" },
        { id: 4, name: "EMPLOYEE" },
    ],
    personDetails: [],
    userHolidays: [],
    hrmsData: [],
    peopleOptionFields: [],
    departmentOptions: [],
    industryData: [],
    roleChoices: [],
    signatures: [],
    version: []
};

export const mutations = {
    SET_VERSION(state, payload) {
        state.version = payload
    },
    ROLE_CHOICES_BEGIN(state) {
        state.loading = false;
        state.error = false;
    },
    ROLE_CHOICES_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.roleChoices = data;
    },
    ROLE_CHOICES_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },

    EMPLOYEES_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },
    EMPLOYEES_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.people = data.results;
    },
    EMPLOYEES_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },
    DEVICES_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },
    DEVICES_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.devices = data;
    },
    DEVICES_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },
    DEPARTMENTS_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },
    DEPARTMENT_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.departments = data;
    },

    EMPLOYMENT_RELATIONSHIP_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },

    EMPLOYMENT_RELATIONSHIP_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.employmentRelationShips = data;
    },

    EMPLOYMENT_RELATIONSHIP_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },
    ROLES_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },

    ROLES_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.roles = data;
    },

    ROLES_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },

    USER_DETAIL_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },

    USER_DETAIL_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.personDetails = data;
    },
    USER_DETAIL_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },
    USER_HOLIDAYS_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },
    USER_HOLIDAYS_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.userHolidays = data;
    },
    USER_HOLIDAYS_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },
    HRMS_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },
    HRMS_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.hrmsData = data;
    },
    HRMS_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },
    PEOPLE_OPTION_FIELDS_START(state) {
        state.loading = true;
        state.error = false;
    },
    PEOPLE_OPTION_FIELDS_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.peopleOptionFields = data;
    },
    PEOPLE_OPTION_FIELDS_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },

    DEPARTMENT_OPTIONS_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },
    DEPARTMENT_OPTIONS_SUCCESS(state, data) {
        state.loading = false;
        state.departmentOptions = data;
        state.error = false;
    },
    DEPARTMENT_OPTIONS_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },

    INDUSTRY_DATA_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },
    INDUSTRY_DATA_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.industryData = data;
    },

    INDUSTRY_DATA_FALURE(state) {
        state.loading = false;
        state.error = true;
    },
    SIGNATURES_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },
    SIGNATURES_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.signatures = data;
    },
    SIGNATURES_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },
};

export const getters = {
    getVersion(state) {
        return state.version
    },
    getIndustryName(state) {
        return state.industryData.length > 0 && state.industryData[0].name != null ?
            state.industryData[0].name :
            "CLOCK N' ROLL";
    },

    getIndustryImage(state) {
        return state.industryData.length > 0 && state.industryData[0].image != null ?
            state.industryData[0].image :
            "CLOCK N' ROLL";
    },

    departmentNames(state) {
        return state.departments.map((e) => e.name);
    },

    hrmsActive(state) {
        if (state.hrmsData.length > 0) {
            return state.hrmsData[0].is_active;
        } else {
            return false;
        }
    },
};

export const actions = {
    async fetchVersion({ commit }) {
        try {
            const resp = await session.get('api/version');
            commit('SET_VERSION', resp.data.version)
        } catch (error) {
            console.log('something went wrong with version')
        }
    },
    async getSignatures({ commit }) {
        commit("SIGNATURES_BEGIN");
        return await session
            .get("api/signatures/")
            .then(({ data }) => commit("SIGNATURES_SUCCESS", data))
            .catch(() => commit("SIGNATURES_FAILURE"));
    },
    async getDevices({ commit }) {
        commit("DEVICES_BEGIN");
        return await session
            .get("api/devices/")
            .then(({ data }) => commit("DEVICES_SUCCESS", data))
            .catch(() => commit("DEVICES_FAILURE"));
    },

    async fetchDepartments({ commit }) {
        commit("DEPARTMENTS_BEGIN");
        return await session
            .get("api/departments/")
            .then(({ data }) => commit("DEPARTMENT_SUCCESS", data));
    },

    async fetchEmploymentRelationship({ commit }) {
        commit("EMPLOYMENT_RELATIONSHIP_BEGIN");
        return await session
            .get("api/emplooyement-relationship/")
            .then(({ data }) => commit("EMPLOYMENT_RELATIONSHIP_SUCCESS", data))
            .catch(() => commit("EMPLOYMENT_RELATIONSHIP_FAILURE"));
    },
    async fetchRolesCount({ commit }) {
        commit("ROLES_BEGIN");
        return await session
            .get("api/roles-count/")
            .then(({ data }) => commit("ROLES_SUCCESS", data))
            .catch(() => commit("ROLES_FAILURE"));
    },

    async fetchPersonDetails({ commit }, { pk }) {
        commit("USER_DETAIL_BEGIN");
        return await session
            .get(`api/user/${pk}/`)
            .then(({ data }) => commit("USER_DETAIL_SUCCESS", data))
            .catch(() => commit("USER_DETAIL_FAILURE"));
    },
    // Check here about HolidayDetailView
    async fetchPersonHolidays({ commit }, { page, userID }) {
        commit("USER_HOLIDAYS_BEGIN");
        return await session
            .get(`api/user/${userID}/holidays/?page=${page}`)
            .then(({ data }) => commit("USER_HOLIDAYS_SUCCESS", data))
            .catch(() => commit("USER_HOLIDAYS_FAILURE"));
    },

    async fetchHrms({ commit }) {
        commit("HRMS_BEGIN");
        return await session
            .get("api/hrms/hrms-list/")
            .then(({ data }) => commit("HRMS_SUCCESS", data))
            .catch(() => commit("HRMS_FAILURE"));
    },

    async fetchPeopleOptionFields({ commit }, { peopleFilter: { department } }) {
        commit("PEOPLE_OPTION_FIELDS_START");
        return await session
            .get(`api/people/option-fields/?${department}`)
            .then(({ data }) => commit("PEOPLE_OPTION_FIELDS_SUCCESS", data))
            .catch(() => commit("PEOPLE_OPTION_FIELDS_FAILURE"));
    },

    async fetchDepartmentOptions({ commit }) {
        commit("DEPARTMENT_OPTIONS_BEGIN");
        return await session
            .get("api/department/options/")
            .then(({ data }) => commit("DEPARTMENT_OPTIONS_SUCCESS", data))
            .catch(() => commit("DEPARTMENT_OPTIONS_FAILURE"));
    },

    async fetchIndystryData({ commit }) {
        commit("INDUSTRY_DATA_BEGIN");
        return await session
            .get("api/industry/retrieve/")
            .then(({ data }) => commit("INDUSTRY_DATA_SUCCESS", data))
            .catch(() => commit("INDUSTRY_DATA_FALURE"));
    },

    async fetchRoleChoices({ commit }) {
        commit("ROLE_CHOICES_BEGIN");
        return await session
            .get("api/people-roles/")
            .then(({ data }) => commit("ROLE_CHOICES_SUCCESS", data))
            .catch(() => commit("ROLE_CHOICES_FAILURE"));
    },
};